import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import ScrollProgressBar from "../ScrollProgressBar";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollProgressBar />
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;


